// Export CSV des clients d'un commerce (droit à la portabilité, réversibilité)
// Séparateur « ; » et BOM UTF-8 : s'ouvre directement dans Excel en français.

const cellule = (v) => {
  const s = v === null || v === undefined ? '' : String(v)
  return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

const date = (iso) => (iso ? new Date(iso).toLocaleString('fr-FR') : '')

export function exporterClientsCSV(clients, visites, nomCommerce) {
  const parClient = {}
  for (const v of visites) {
    const p = (parClient[v.client_id] ||= { nombre: 0, derniere: null })
    p.nombre += 1
    if (!p.derniere || v.created_at > p.derniere) p.derniere = v.created_at
  }

  const entetes = ['Prénom', 'Téléphone', 'Tampons actuels', 'Nombre de visites', 'Dernière visite',
    'Inscrit le', 'Inscription', 'Accepte les offres', 'Date du consentement']
  const lignes = clients.map(c => [
    c.nom,
    c.telephone,
    c.tampons || 0,
    parClient[c.id]?.nombre || 0,
    date(parClient[c.id]?.derniere),
    date(c.created_at),
    c.source === 'qr' ? 'QR code' : 'Comptoir',
    c.consentement_offres ? 'Oui' : 'Non',
    date(c.consentement_at),
  ])

  const csv = '﻿' + [entetes, ...lignes].map(l => l.map(cellule).join(';')).join('\r\n')
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }))
  const a = document.createElement('a')
  const slug = (nomCommerce || 'commerce').toLowerCase().normalize('NFD').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
  a.href = url
  a.download = `jeebi-clients-${slug}-${new Date().toISOString().slice(0, 10)}.csv`
  a.click()
  URL.revokeObjectURL(url)
}
